import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FixtureItem } from '@/types/sportsFixture';

interface FixtureState {
  fixtureData: FixtureItem | null;
}

const initialState: FixtureState = {
  fixtureData: null,
};

const fixtureSlice = createSlice({
  name: 'fixture',
  initialState,
  reducers: {
    setFixtureData: (state, action: PayloadAction<FixtureItem>) => {
      state.fixtureData = action.payload;
    },
    resetFixtureData: (state) => {
      state.fixtureData = null;
    },
  },
});

export const { setFixtureData, resetFixtureData } = fixtureSlice.actions;

export default fixtureSlice.reducer;
